import { render, staticRenderFns } from "./AuthorProfile.vue?vue&type=template&id=de675b1c"
import script from "./AuthorProfile.vue?vue&type=script&lang=js"
export * from "./AuthorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports